import { z } from "zod";
export const mediaKindSchema = z.enum(["photo", "video"]);
// Cursor is `<iso-timestamp>:<id>`. ISO timestamps contain colons themselves
// (e.g. `2024-12-31T18:30:45.000Z:1234`), so the regex must allow them — match
// any non-empty prefix, a literal colon, then digits to end.
export const cursorSchema = z.string().regex(/^.+:\d+$/);
export const mediaListQuerySchema = z.object({
    kind: mediaKindSchema.optional(),
    tag: z.string().optional(),
    tags: z.string().optional(),
    excludeTags: z.string().optional(),
    before: cursorSchema.optional(),
    limit: z.coerce.number().int().min(1).max(200).default(60),
    // Named scope. Today only "favorites" — adds an INNER JOIN against the
    // current user's favorites. Other scopes (photos/videos/tag:slug) use the
    // existing kind=/tag= params; only add a new value here when a scope can't
    // be expressed that way.
    set: z.enum(["favorites"]).optional(),
});
export const tagCreateSchema = z.object({
    name: z.string().trim().min(1).max(80),
});
export const tagAddSchema = z.object({
    tagIds: z.array(z.number().int().positive()).min(1).max(50),
});
// Finalize accepts an optional set of session tag IDs to attach to the
// newly-stored media (or, on a duplicate, to the existing media). Optional
// and capped like tagAddSchema; absent/empty means "tag nothing".
export const uploadFinalizeSchema = z.object({
    tagIds: z.array(z.number().int().positive()).max(50).optional(),
});
// Init accepts an optional pre-computed SHA-256 (lowercase hex) and the same
// session tag IDs finalize takes. When sha256 is present the server can detect
// a duplicate before any chunk is uploaded. filename/sizeBytes are validated
// by the handler's bespoke checks (specific 400 bad_size / 413 file_too_large
// responses), so they're intentionally not part of this schema — unknown keys
// are stripped.
export const uploadInitSchema = z.object({
    sha256: z
        .string()
        .regex(/^[0-9a-f]{64}$/)
        .optional(),
    tagIds: z.array(z.number().int().positive()).max(50).optional(),
});
export const bulkTagSchema = z.object({
    mediaIds: z.array(z.number().int().positive()).min(1).max(5000),
    addTagIds: z.array(z.number().int().positive()).max(5000).default([]),
    removeTagIds: z.array(z.number().int().positive()).max(5000).default([]),
});
export const bulkDeleteSchema = z.object({
    mediaIds: z.array(z.number().int().positive()).min(1).max(5000),
});
export const bulkRetranscodeSchema = z.object({
    mediaIds: z.array(z.number().int().positive()).max(5000).optional(),
    all: z.boolean().optional(),
});
